import { GridLoader } from "react-spinners";


export default function Loader({ color = "#4878cf", loading = true, size = 15 }) {
    const cssOverride = {
        display: 'block',
        margin: '0 auto',
    };

    return <GridLoader color={color} css={cssOverride} loading={loading} size={size} />;
}
